import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSynchronizeArrowsSquare2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7.62 28.185h12.19v1.53H7.62Zm-1.52-1.52h1.52v1.52H6.1Zm0-6.1h4.57v-1.52H9.15v-1.52H7.62v-1.53H6.1v-1.52H4.58v1.52H3.05v1.53H1.53v1.52H0v1.52h4.58v6.1H6.1zm21.33-9.14v-6.09h-1.52v6.09h-4.57v1.52h1.52v1.53h1.53v1.52h1.52v1.53h1.52v-1.53h1.53v-1.52h1.52v-1.53H32v-1.52zm-3.04-7.62h1.52v1.53h-1.52Zm-12.2-1.52h12.2v1.52h-12.2Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSynchronizeArrowsSquare2
